'use strict';
import React from 'react';

/**
 * Defines a site wide header which contains the conversant name and logo,
 * a site title, and an optional user greeting button. Typically this button
 * is provided for user actions (i.e. logout, or settings).
 *
 * The default position for SiteHeader is fixed, so a primary container element
 * should be used with the SiteContent and SiteContent--withHeader classes
 * to provide an offset for the SiteHeader (padding-top: 53px).
 *
 * @extends {React.Compponent}
 * @property {String} title Site header title.
 */
class SiteHeader extends React.Component {
  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    return (
      <div className="SiteHeader">
        <div className="SiteHeader-logo"></div>
        <div className="SiteHeader-title">{this.props.title}</div>
        {this.props.children}
      </div>
    );
  }
}

SiteHeader.defaultProps = {
  title: 'Conversant'
};

export default SiteHeader;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/siteHeader/siteHeader.jsx